import { getCookie } from '../utils/cookies';

export interface WishlistResponse {
    success: boolean;
    type: 'success-add' | 'success-remove' | 'success' | 'error';
    message: string;
    data?: {
        items_count?: number;
        items?: string[];
    };
}

export interface WishlistApiParams {
    share_key: string;
    post_id: string;
    type: 'add' | 'remove';
    user_id?: string;
}

class WishlistService {
    private baseUrl = '/wp-json/weltweitwandern/wishlist';

    private getShareKey(): string {
        return getCookie('wishlist');
    }

    async getItems(): Promise<WishlistResponse> {
        const shareKey = this.getShareKey();

        if (!shareKey) {
            // Return empty wishlist if no cookie is set
            return {
                success: true,
                type: 'success',
                message: 'Merkliste ist leer',
                data: {
                    items: [],
                    items_count: 0
                }
            };
        }

        const params = new URLSearchParams({
            share_key: shareKey
        });

        const url = `${this.baseUrl}/get-items/?${params}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Wishlist API error:', error);
            throw error;
        }
    }

    async addItem(postId: string): Promise<WishlistResponse> {
        return this.makeRequest(postId, 'add');
    }

    async removeItem(postId: string): Promise<WishlistResponse> {
        return this.makeRequest(postId, 'remove');
    }

    private async makeRequest(postId: string, type: 'add' | 'remove'): Promise<WishlistResponse> {
        const shareKey = this.getShareKey();

        if (!shareKey) {
            throw new Error('Wishlist share key not found');
        }

        const params = new URLSearchParams({
            share_key: shareKey,
            post_id: postId,
            type: type
        });

        try {
            const response = await fetch(`${this.baseUrl}/add-remove-item/?${params}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Wishlist API error:', error);
            throw error;
        }
    }
}

export const wishlistService = new WishlistService();